import { render, staticRenderFns } from "./MainSlider.vue?vue&type=template&id=3a533d15&scoped=true"
import script from "./MainSlider.vue?vue&type=script&lang=js"
export * from "./MainSlider.vue?vue&type=script&lang=js"
import style0 from "./MainSlider.vue?vue&type=style&index=0&id=3a533d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a533d15",
  null
  
)

export default component.exports